import {
  call,
  put,
  takeLatest,
  select,
  all,
  takeEvery,
} from 'redux-saga/effects';

import { isEmpty } from 'src/utils';
import {
  GET_DEMOGRAPHICS_REQUEST,
  GET_DEMOGRAPHICS_SUCCESS,
  GET_DEMOGRAPHICS_SEARCH_RESULTS_SUCCESS,
  GET_DEMOGRAPHICS_SEARCH_RESULTS_REQUEST,
} from '../constants/action-types';

import * as api from '../services/engineApi';
import { getSources } from '../utils/AuthHelperMethods';
import { getCurrentProductDataSources } from '../selectors/myCompany';

const getQueryString = (q, categoryId, sources) => {
  const queryStringArr = [];

  queryStringArr.push(`variable_types=demographic`);

  if (q) {
    queryStringArr.push(`q=${q}`);
  }

  if (categoryId) {
    queryStringArr.push(`category_id=${categoryId}`);
  }

  queryStringArr.push(`sources=${sources}`);

  return `?${queryStringArr.join('&')}`;
};

function* fetchDemographics(action) {
  const demographicsItems = yield select(state => state.demographicsItems);
  const productDataSources = yield select(state =>
    getCurrentProductDataSources(state)
  );
  let allDemographics = demographicsItems.data;

  if (!demographicsItems.loaded) {
    let dataSources = ['twitter'];

    if (!isEmpty(productDataSources)) {
      dataSources = dataSources.concat(...productDataSources);
    }

    const promises = dataSources.map(dataSource => {
      return call(api.fetchDemographicsApi, dataSource);
    });

    const allDemographicsResponse = yield all(promises);

    allDemographics = allDemographicsResponse.reduce((acc, result, i) => {
      const { response, error } = result;

      if (!error) {
        acc[dataSources[i]] = response.data;
      } else {
        acc[dataSources[i]] = [];
      }
      return acc;
    }, {});
  }
  return yield put({
    type: GET_DEMOGRAPHICS_SUCCESS,
    response: allDemographics,
  });
}

function* fetchDemographicsSearchResults(action) {
  const { q, categoryId } = action;
  const productDataSources = yield select(state =>
    getCurrentProductDataSources(state)
  );

  let dataSources = ['twitter'];

  if (!isEmpty(productDataSources)) {
    dataSources = dataSources.concat(...productDataSources);
  }

  const promises = dataSources.map(dataSource => {
    const sources = getSources(dataSource);

    const queryString = getQueryString(q, categoryId, sources);
    return call(api.fetchExploreItemsApi, queryString);
  });

  const allDemographicsResponse = yield all(promises);

  const allDemographics = allDemographicsResponse.reduce((acc, result, i) => {
    const { response, error } = result;

    if (!error) {
      acc[dataSources[i]] = response.data;
    } else {
      acc[dataSources[i]] = [];
    }
    return acc;
  }, {});

  return yield put({
    type: GET_DEMOGRAPHICS_SEARCH_RESULTS_SUCCESS,
    response: allDemographics,
    demographicKey: categoryId,
  });
}

export function* demographicActionWatcher() {
  yield takeLatest(GET_DEMOGRAPHICS_REQUEST, fetchDemographics);
  yield takeEvery(
    GET_DEMOGRAPHICS_SEARCH_RESULTS_REQUEST,
    fetchDemographicsSearchResults
  );
}
